import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import './SignUp.css'

const SetPinCodeUI = ({ context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
  // pin code
  pinCode, onPinCodeChange, pinCodeError, setPinCodeError
}) =>
  <CardUI context={context}>
    <FormSF context={context} className='pub_signup' messageList={messageList} buttonMessageKey='c_confirm'
      onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      busy={submitted}>
      <InputTextSF type='password' name='pinCode' required={true}
        maxLength={8} autoFocus={true}
        messageList={messageList} labelKey='c_pin_code'
        value={pinCode} onChange={onPinCodeChange}
        error={pinCodeError} setError={setPinCodeError}
      />
    </FormSF>
  </CardUI>

export default SetPinCodeUI
